module.exports = __webpack_public_path__ + "img/a9.0c2602c8.jpeg";